'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Box = require('./Box');

var _Box2 = _interopRequireDefault(_Box);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Header = function (_Component) {
  _inherits(Header, _Component);

  function Header() {
    _classCallCheck(this, Header);

    return _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).apply(this, arguments));
  }

  _createClass(Header, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          level = _props.level,
          sub = _props.sub,
          dividing = _props.dividing,
          block = _props.block,
          thinner = _props.thinner,
          bolder = _props.bolder,
          className = _props.className,
          rest = _objectWithoutProperties(_props, ['level', 'sub', 'dividing', 'block', 'thinner', 'bolder', 'className']);

      var cx = (0, _classnames2.default)({
        sub: sub,
        dividing: dividing,
        block: block,
        thinner: thinner,
        bolder: bolder
      }, 'header', className);

      if (level) {
        rest.wrapper = 'h' + level;
      }

      return _react2.default.createElement(_Box2.default, _extends({
        ts: true,
        className: cx
      }, rest));
    }
  }]);

  return Header;
}(_react.Component);

Header.displayName = 'Header';

Header.propTypes = {
  level: _propTypes2.default.number,
  sub: _propTypes2.default.bool,
  dividing: _propTypes2.default.bool,
  block: _propTypes2.default.bool,
  thinner: _propTypes2.default.bool,
  bolder: _propTypes2.default.bool
};

exports.default = Header;
//# sourceMappingURL=data:application/json;charset=utf8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkhlYWRlci5qcyJdLCJuYW1lcyI6WyJIZWFkZXIiLCJwcm9wcyIsImxldmVsIiwic3ViIiwiZGl2aWRpbmciLCJibG9jayIsInRoaW5uZXIiLCJib2xkZXIiLCJjbGFzc05hbWUiLCJyZXN0IiwiY3giLCJ3cmFwcGVyIiwiZGlzcGxheU5hbWUiLCJwcm9wVHlwZXMiLCJudW1iZXIiLCJib29sIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7O0FBQUE7Ozs7QUFDQTs7OztBQUNBOzs7O0FBQ0E7Ozs7Ozs7Ozs7Ozs7O0lBRU1BLE07Ozs7Ozs7Ozs7OzZCQUNLO0FBQUEsbUJBVUgsS0FBS0MsS0FWRjtBQUFBLFVBRUxDLEtBRkssVUFFTEEsS0FGSztBQUFBLFVBR0xDLEdBSEssVUFHTEEsR0FISztBQUFBLFVBSUxDLFFBSkssVUFJTEEsUUFKSztBQUFBLFVBS0xDLEtBTEssVUFLTEEsS0FMSztBQUFBLFVBTUxDLE9BTkssVUFNTEEsT0FOSztBQUFBLFVBT0xDLE1BUEssVUFPTEEsTUFQSztBQUFBLFVBUUxDLFNBUkssVUFRTEEsU0FSSztBQUFBLFVBU0ZDLElBVEU7O0FBV1AsVUFBSUMsS0FBSywwQkFDUDtBQUNFUCxnQkFERjtBQUVFQywwQkFGRjtBQUdFQyxvQkFIRjtBQUlFQyx3QkFKRjtBQUtFQztBQUxGLE9BRE8sRUFRUCxRQVJPLEVBU1BDLFNBVE8sQ0FBVDs7QUFZQSxVQUFJTixLQUFKLEVBQVc7QUFDVE8sYUFBS0UsT0FBTCxTQUFtQlQsS0FBbkI7QUFDRDs7QUFFRCxhQUNFO0FBQ0UsZ0JBREY7QUFFRSxtQkFBV1E7QUFGYixTQUdNRCxJQUhOLEVBREY7QUFPRDs7Ozs7O0FBR0hULE9BQU9ZLFdBQVAsR0FBcUIsUUFBckI7O0FBRUFaLE9BQU9hLFNBQVAsR0FBbUI7QUFDakJYLFNBQU8sb0JBQVVZLE1BREE7QUFFakJYLE9BQUssb0JBQVVZLElBRkU7QUFHakJYLFlBQVUsb0JBQVVXLElBSEg7QUFJakJWLFNBQU8sb0JBQVVVLElBSkE7QUFLakJULFdBQVMsb0JBQVVTLElBTEY7QUFNakJSLFVBQVEsb0JBQVVRO0FBTkQsQ0FBbkI7O2tCQVNlZixNIiwiZmlsZSI6IkhlYWRlci5qcyIsInNvdXJjZVJvb3QiOiJEOlxcUHJvamVjdHNcXHJlYWN0LXRvY2FzXFxzcmMifQ==



//////////////////
// WEBPACK FOOTER
// ../lib/Header.js
// module id = 567
// module chunks = 0